<template>
  <el-card :body-style="bodyStyle">
    <div :class="$setClasses">
      <div :class="$vClass('before')">
        <mover-description :display-link="displayLink"
                           :mover="offer.mover"
                           :offer-id="offer.id"
                           display-rates/>
        <div v-if="(offer.services && offer.services.length)
         || (!optionsValided && offer.options && offer.options.length)
          || optionsSelected.length"
               :class="$vClass('services')">
          <offer-services v-if="offer.services && offer.services.length"
                          :services="offer.services"
                          :title="$t('comparator.offers.offer.includedServices')" />
          <offer-options v-if="offer.options && offer.options.length"
                         :display-checkbox="!optionsValided"
                         :is-checkbox-disabled="!isInitialStatus"
                         :hide-price="hidePriceInfo"
                         :options="offer.options"
                         :offer-id="offer.id" />
        </div>
      </div>
      <div :class="[$vClass('after'), actionsClass]">
        <offer-price v-if="!hidePriceInfo"
                     :class="priceClass"
                     :offer="offer" />
        <slot
          v-if="$scopedSlots.actions"
          name="actions"
          :offer="offer" />
      </div>
    </div>
    <slot
      v-if="$scopedSlots.footer"
      name="footer"
      :offer="offer" />
  </el-card>
</template>

<script>
import { mapGetters } from 'vuex';
import MoverDescription from './fragments/MoverDescription.vue';
import OfferServices from './fragments/OfferServices.vue';
import OfferOptions from './fragments/OfferOptions.vue';
import OfferPrice from './fragments/OfferPrice.vue';
import offersHelper from '../../utils/helpers/offers';

export default {
  name: 'Offer',
  nameClassStyle: 'offer',
  components: {
    MoverDescription,
    OfferServices,
    OfferOptions,
    OfferPrice,
  },
  props: {
    offer: {
      type: Object,
      default: () => ({}),
    },
    index: {
      type: Number,
      default: null,
    },
    displayLink: Boolean,
    optionsValided: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapGetters({
      demandStore: 'demandStore/demand',
      projectSelected: 'projectStore/projectSelected',
      offersStore: 'offerStore/offers',
    }),
    isInitialStatus() {
      return offersHelper.isInitialStatus(this.offer);
    },
    bodyStyle() {
      const style = {
        width: '100%',
      };
      if (this.$scopedSlots.footer) {
        style['padding-bottom'] = 0;
      }
      return style;
    },
    actionsClass() {
      return {
        'offer__after--no-actions': !this.$scopedSlots.actions,
        'offer__after--no-price': this.hidePriceInfo,
      };
    },
    priceClass() {
      return {
        'offer__actions__price--no-actions': !this.$scopedSlots.actions,
      };
    },
    optionsSelected() {
      return this.offer.options.filter((option) => option.is_chosen);
    },
    isInitialState() {
      return offersHelper.isInitialState(this.offersStore, this.projectSelected.params.prebooked);
    },
    hidePriceInfo() {
      return this.projectSelected && this.projectSelected.params.hide_price_info;
    },
  },
};
</script>

<style scoped lang="scss">
.offer {
  display: flex;
  flex-direction: column;
  box-shadow: none;
  border-color: transparent;

  $--space-small: var(--nxt-space-small);
  $--space-default: var(--nxt-space-default);

  @include breakpoint(tablet) {
    flex-direction: row;

    .offer {
      &__before {
        padding: {
          right: $--space-default;
          bottom: 0;
        }
      }

      :deep(.price__panel) {
        padding: $--space-default;
      }

      :deep(.offer__actions) {
        padding: 0 $--space-default $--space-default;
      }
    }
  }

  &.--is-recommend-offer {
    &.el-card, :deep(.el-card__body) {
      border-radius: 0 0 var(--nxt-border-radius-base) var(--nxt-border-radius-base);
      border-top: 0;
      border-color: var(--nxt-color-athens-grayapprox);
    }
  }

  &:not(.--is-recommend-offer) {
    &.el-card, :deep(.el-card__body) {
      border-radius: var(--nxt-border-radius-base);
    }
  }

  :deep(.el-card__body) {
    background: var(--nxt-color-athens-grayapprox);
  }

  &__after, :deep(.price__panel), &__mover__img-wrapper {
    background: var(--nxt-color-white);
  }

  &__before {
    flex: 1;
    padding-bottom: $--space-default;
  }

  &__services {
    flex: 1;
    padding: {
      top: $--space-default;
      left: var(--nxt-space-xxxsmall);
    }
  }

  :deep(.el-checkbox.is-disabled) {
    .el-checkbox {

      &__label, &__inner {
        cursor: default;
      }

      &__label {
        color: var(--nxt-color-primary);
      }

      &__inner::after {
        border-color: var(--nxt-color-primary);
      }
    }
  }

  &__after {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    min-width: 240px;
    border-radius: var(--nxt-border-radius-base);

    :deep(.price), :deep(.price__panel), :deep(.minarm-action.offer__actions) {
      border-radius: var(--nxt-border-radius-base);
    }

    &--no-price {
      justify-content: flex-end;
    }

    &--no-actions {
      display: flex;
    }
    &__price {
      &--no-actions {
        height: 100%;
      }
    }

    :deep(.price__panel) {
      padding: $--space-default;
    }

    :deep(.offer__actions) {
      padding: $--space-default;

      flex: inherit;
    }
  }

  &__services > div:last-child {

    :deep(ul) {
      margin-bottom: 0;
    }
  }
}
</style>
